export default `
  query GetAvailableWeights {
    getAvailableWeights
  }
`;
